import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useHRM3050_R01Store } from "./Store_HRM3050_R01";

/** Container에서 전달받는 값의 모양이다. */
interface Props {
    onRecalculateClick: () => void; // "일일근태 재계산" 버튼을 눌렀을 때 실행할 함수
}

/**
 * 근무조 사용여부 검색 콤보와 화면 전용 "일일근태 재계산" 버튼을 표시한다. 조회는 상위 액션바의 조회 버튼으로 실행한다.
 * 버튼 배치는 검색 영역에 화면 전용 버튼을 두는 EQM3010_R01(전년계획복사)과 같다.
 * @param onRecalculateClick 재계산 버튼 클릭 함수
 * @returns 현재 Store 검색 조건이 반영된 검색 영역 JSX
 */
export const HRM3050_R01SearchSection = ({ onRecalculateClick }: Props) => {
    // 화면 Store에서 현재 검색 조건과 변경 함수를 가져온다.
    const { HRM3050_R01Filter, setHRM3050_R01Filter } = useHRM3050_R01Store();
    // 공통코드 Store에서 사용여부(YESNO) 선택 목록을 가져온다.
    const { yesNoList } = useCommonCodeStore();

    // 공통코드 선택 시 minorCd를 저장하고, 전체 선택 시 빈 문자열을 저장한다.
    return (
        <SearchSectionForm>
            {/* 사용여부 콤보: 근무조 목록에만 적용된다. 휴게는 선택 근무조의 전체 휴게를 보여 준다. */}
            <SearchDropDownForm
                label="사용여부"
                value={HRM3050_R01Filter.useYn}
                optionList={yesNoList}
                // ?.: 선택 항목이 없으면(전체) undefined가 되어 ||에 의해 빈 문자열을 저장한다.
                onChangeItem={selectedItem => setHRM3050_R01Filter({ useYn: selectedItem?.minorCd || '' })}
            />
            {/* 일일근태 재계산 버튼: 저장한 근무조·휴게 기준으로 일일근태 시간을 다시 계산하도록 요청한다. */}
            <button
                type="button"
                onClick={onRecalculateClick}
                className="flex-shrink-0 bg-white hover:bg-gray-100 ml-20 border border-gray-300 text-gray-800 font-semibold px-4 rounded shadow h-[30px]"
            >
                일일근태 재계산
            </button>
        </SearchSectionForm>
    );
};
